// /*************************************************/
// /* LOTTIE ANIMATIONS                             */
// /*************************************************/
import lottie from "lottie-web";

export function lottieAnimation() {
    const init = function () {
        var lottieElements = document.querySelectorAll(".lottie");

        lottieElements.forEach(function (element) {
            var animationPath = element.getAttribute("data-lottie-json");
            var loop = true; // Default loop value
            var delay = 0; // Default delay value

            // Load animation
            var animation = lottie.loadAnimation({
                container: element,
                renderer: 'svg',
                loop: loop,
                autoplay: false,
                path: animationPath
            });

            element.lottieInstance = animation;

            // Create Intersection Observer
            const observer = new IntersectionObserver(handleIntersection, { threshold: [0, 0.5, 1] });

            // Observe the element
            observer.observe(element);

            function handleIntersection(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (delay > 0) {
                            setTimeout(() => {
                                animation.play();
                            }, delay);
                        } else {
                            animation.play();
                        }
                    } else {
                        animation.pause();
                    }
                });
            }
        });
    };

    init();
}
